import get from 'lodash/get'

import { GET } from 'actions/apiActions'
import { MERGE_ENTITIES } from 'reducers/entityReducers'
import { REPLACE_LEAD_LIST } from 'reducers/leadReducers'

import { initPins } from 'actions/inventoryActions'
import { dateStringtoMsRange } from 'utils'
import { getSelectedDateRange, getLeadLastSeen } from 'selectors/leadSelectors'

export const getLeadDetails = (
    sessionId,
    { withPins = true } = {},
  ) => dispatch => {
    return dispatch(GET.leadDetails({}, { sessionId })).then(r => {
      let vehicleIds = get(r, 'summary.vehicleIds', [])

      dispatch({
        type: MERGE_ENTITIES,
        payload: {
          [sessionId]: {
            ...r,
            _entityType: 'lead',
          },
        },
      })
      withPins &&
        vehicleIds.length > 0 &&
        dispatch(
          initPins(
            vehicleIds.reduce((ret, id) => ({ ...ret, [id]: null }), {}),
          ),
        )
    })
  },
  getLeads = dateRange => (dispatch, getState) => {
    dateRange = dateRange || getSelectedDateRange(getState())

    return dispatch(
      GET.leads({ queryStringParameters: dateStringtoMsRange(dateRange) }),
    ).then((leads = {}) => {
      dispatch({
        type: MERGE_ENTITIES,
        payload: Object.keys(leads).reduce(
          (ret, k) => ({ ...ret, [k]: { ...leads[k], _entityType: 'lead' } }),
          {},
        ),
      })

      dispatch({
        type: REPLACE_LEAD_LIST,
        payload: Object.keys(leads).sort((a, b) => {
          return getLeadLastSeen(leads[b]) - getLeadLastSeen(leads[a])
        }),
      })
    })
  }
